import {Provider} from "react-redux";
import {ThemeProvider} from "styled-components";
import {GlobalStyles, lightTheme} from "@/styles/ThemeConfig";
import Head from "next/head";
import {useStore} from "@/redux/store";
import {useRouter} from "next/router";

function App({ Component, pageProps }) {
    const store = useStore(pageProps.initialReduxState);
    const router = useRouter();

    // Base URL from environment variables or fallback
    const baseURL = process.env.NEXT_PUBLIC_BASE_URL || "https://web.secrettours.com";
    const canonicalURL = `${baseURL}${router.asPath.split("?")[0]}`;

    // Metadata defaults
    const defaultMeta = {
        title: "Default Title",
        description: "Default description of the website.",
        image: "https://web.secrettours.com/images/meta_default_poster.jpg",
    };

    const meta = { ...defaultMeta, ...pageProps.metadata };

    return (
        <Provider store={store}>
            <Head>
                {/* Dynamic Metadata */}
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <meta property="og:title" content={meta.title} />
                <meta property="og:description" content={meta.description} />
                <meta property="og:image" content={meta.image} />
                <meta property="og:type" content="product" />
                <meta property="og:url" content={canonicalURL} />
                <meta name="twitter:title" content={meta.title} />
                <meta name="twitter:description" content={meta.description} />
                <meta name="twitter:image" content={meta.image} />
                <meta name="twitter:card" content="summary_large_image" />

                {/* Static Metadata */}
                <link rel="icon" href="/favicon.ico" />
                <link rel="manifest" href="/site.webmanifest" />
                <meta name="msapplication-TileColor" content="#da532c" />
                <meta name="theme-color" content="#ffffff" />
                <link rel="canonical" href={canonicalURL} />

                {/* Add Structured Data if it exists */}
                {pageProps?.structuredData && (
                    <script
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                            __html: JSON.stringify(pageProps.structuredData),
                        }}
                    />
                )}
            </Head>
            <ThemeProvider theme={lightTheme}>
                <GlobalStyles />
                <Component {...pageProps} />
            </ThemeProvider>
        </Provider>
    );
}

export default App;
